import { PropertyType } from 'esa-ui-library/lib/types';
import { reportConstants } from '../../constants/reports';
import { OptionType, TableHeaderType } from '../../../common';

export const getFiltersUrl = (filters: PropertyType[]): string => {
	const urlFragments = filters.map((f) => `${f.name}=${f.value}`);
	return `?${urlFragments.join('&')}`;
};

export const filterPlayerFieldsByEnv = (fields: TableHeaderType[]): TableHeaderType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter(
			(f) =>
				f.label !== reportConstants.REPORT_EMAIL &&
				f.label !== reportConstants.REPORT_FIRST_NAME &&
				f.label !== reportConstants.REPORT_LAST_NAME &&
				f.label !== reportConstants.REPORT_COUNTRY &&
				f.label !== reportConstants.REPORT_VIP_LEVEL &&
				f.label !== reportConstants.REPORT_EXT_PLAYER_ID
		);
	}

	return result;
};

export const filterSearchOptionsByEnv = (fields: OptionType[]): OptionType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter((f) => f.value !== 'external_player_ids');
	}

	return result;
};
